import { render, staticRenderFns } from "./VueLoadingCover.vue?vue&type=template&id=04a8e268&"
import script from "./VueLoadingCover.vue?vue&type=script&lang=js&"
export * from "./VueLoadingCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports